import { SESSION_DETAILS_LOADED } from './types';

export const sessionDetailsLoaded = () => ({
  type: SESSION_DETAILS_LOADED,
});
